import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Landmark, FileSearch } from 'lucide-react';
import { PageHeader, Card } from '../ui';
import { api, eur } from '../api';
import RequestForm from '../immobili/RequestForm';
import RequestsList from '../immobili/RequestsList';
import MortgageForm from '../immobili/MortgageForm';
import MortgageList from '../immobili/MortgageList';

const ACTIVE = ['queued', 'running', 'captcha', 'submitted'];
const TYPES = [
  [Landmark, 'property_cadastral', 'Visura catastale nazionale', 'Elenco dei beni immobili intestati in tutta Italia, per persone fisiche e giuridiche, direttamente dalla banca dati catastale dell\'Agenzia delle Entrate.'],
  [FileSearch, 'property_mortgage_national', 'Ispezione ipotecaria', 'Ipoteche, pignoramenti e passaggi di proprietà in tutta Italia (persone fisiche): ricerca nazionale, elenco sintetico per conservatoria e apertura delle singole note.'],
];

export default function ImmobiliPage() {
  const [params] = useSearchParams();
  const [prices, setPrices] = useState({});
  const [enabled, setEnabled] = useState(false);
  const [mortgageOn, setMortgageOn] = useState(false);
  const [items, setItems] = useState([]);
  const [mortgage, setMortgage] = useState([]);
  const load = useCallback(() => {
    api.get('/property/requests').then((r) => setItems(r.data)).catch(() => {});
    api.get('/property/mortgage').then((r) => setMortgage(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    api.get('/cs/prices').then((r) => setPrices(r.data)).catch(() => {});
    api.get('/property/status').then((r) => { setEnabled(r.data.enabled); setMortgageOn(!!r.data.mortgage_enabled); }).catch(() => {});
    load();
  }, [load]);
  const busy = items.some((r) => ACTIVE.includes(r.status)) || mortgage.some((r) => ['queued', 'running'].includes(r.status)
    || r.conservatorie.some((c) => ['queued', 'running'].includes(c.status)) || r.notes.some((n) => ['queued', 'running', 'submitted'].includes(n.status)));
  useEffect(() => {
    if (!busy) return undefined;
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [busy, load]);
  const avail = { property_cadastral: enabled, property_mortgage_national: mortgageOn };
  return (
    <div data-testid="immobili-page">
      <PageHeader kicker="Patrimonio immobiliare" title="Immobili" />
      {!enabled && <p className="text-sm text-[#8A8F97] -mt-4 mb-8 max-w-2xl" data-testid="immobili-inactive-note">Collegamento con la banca dati catastale in attivazione: potrai richiedere la visura catastale appena il servizio sarà attivo.</p>}
      <RequestForm initial={{ name: params.get('name'), kind: params.get('kind'), code: params.get('code') }} enabled={enabled} price={prices.property_cadastral?.cents} onDone={load} />
      <div className="grid sm:grid-cols-2 gap-4">
        {TYPES.map(([Icon, key, t, d], i) => (
          <Card key={key} className={`p-6 ${avail[key] ? '' : 'opacity-80'}`} data-testid={`immobili-item-${i}`}>
            <div className="flex items-start justify-between gap-3 mb-4">
              <Icon size={20} className="text-[#D4AF37]" />
              <span className={`text-[10px] font-mono tracking-wider px-2 py-1 border rounded-sm ${avail[key] ? 'border-green-900 text-green-400' : 'border-[#1F242C] text-[#8A8F97]'}`}>{avail[key] ? 'DISPONIBILE' : 'NON DISPONIBILE'}</span>
            </div>
            <p className="text-base text-[#F2F2F2] mb-1">{t}</p>
            <p className="text-sm text-[#8A8F97]">{d}</p>
            {prices[key] && <p className="text-xs font-mono text-[#D4AF37] mt-3" data-testid={`immobili-price-${key}`}>{eur(prices[key].cents)}</p>}
          </Card>
        ))}
      </div>
      <RequestsList items={items} />
      <div className="mt-10"><MortgageForm enabled={mortgageOn} price={prices.property_mortgage_national?.cents} onDone={load} /></div>
      <MortgageList items={mortgage} prices={prices} onDone={load} />
    </div>
  );
}
